import React from 'react';

const RED = '#FF0000';
const YELLOW = '#facc15';
const LIGHT_GREEN = '#92D050';
const NO_SIGNAL = '#FFFFFF';
const EMPTY_SLOT = '#E5E7EB';
const BORDER_NEUTRAL = '#9ca3af';

const BAR_W = 5;
const GAP = 2;
const ROW_H = 20;
const HEIGHTS_PX = [6, 10, 14, 18];
const TRACK_W = BAR_W * 4 + GAP * 3;
const RX = 1;

function StrengthBars({ value }) {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

  const filledCount =
    normalized === 'very weak'
      ? 1
      : normalized === 'weak'
        ? 2
        : normalized === 'medium'
          ? 3
          : normalized === 'strong'
            ? 4
            : 0;

  const fillColor =
    normalized === 'very weak' || normalized === 'weak'
      ? RED
      : normalized === 'medium'
        ? YELLOW
        : normalized === 'strong'
          ? LIGHT_GREEN
          : null;

  const tooltip =
    value != null && value !== '' ? String(value) : 'No Signal';
  const ariaLabel =
    value != null && value !== ''
      ? `Signal strength: ${value}`
      : 'Signal strength: No Signal';

  return (
    <svg
      width={TRACK_W}
      height={ROW_H}
      viewBox={`0 0 ${TRACK_W} ${ROW_H}`}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0, verticalAlign: 'middle' }}
      role="img"
      aria-label={ariaLabel}
    >
      <title>{tooltip}</title>
      {[0, 1, 2, 3].map((i) => {
        const x = i * (BAR_W + GAP);
        const h = HEIGHTS_PX[i];
        const y = ROW_H - h;
        const active = i < filledCount && fillColor;
        const fill = active
          ? fillColor
          : filledCount === 0
            ? NO_SIGNAL
            : EMPTY_SLOT;

        return (
          <g key={i}>
            <rect x={x} y={y} width={BAR_W} height={h} rx={RX} ry={RX} fill={fill} />
            {!active && (
              <rect
                x={x + 0.5}
                y={y + 0.5}
                width={BAR_W - 1}
                height={h - 1}
                rx={RX - 0.5}
                ry={RX - 0.5}
                fill="none"
                stroke={BORDER_NEUTRAL}
                strokeWidth={1}
                vectorEffect="nonScalingStroke"
              />
            )}
          </g>
        );
      })}
    </svg>
  );
}

export default StrengthBars;
